import { render, staticRenderFns } from "./punchAdmin.vue?vue&type=template&id=1b0f27d4&scoped=true&"
import script from "./punchAdmin.vue?vue&type=script&lang=js&"
export * from "./punchAdmin.vue?vue&type=script&lang=js&"
import style0 from "./punchAdmin.vue?vue&type=style&index=0&id=1b0f27d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0f27d4",
  null
  
)

export default component.exports